import useToaster from '../../toaster/hooks/useToaster';

declare type CopyFn = (text: string, successMessage?: string) => Promise<boolean>;

export function useReactClipboard() {
  const toaster = useToaster();

  const isSupported = Boolean(navigator?.clipboard);

  const copy: CopyFn = async (text, successMessage) => {
    if (!isSupported) {
      console.warn('Clipboard not supported');
      return false;
    }

    try {
      await navigator.clipboard.writeText(text);
      handleClipboardResponse(successMessage);
      return true;
    } catch (e) {
      console.warn('Copy failed', e);
      return false;
    }
  };

  const handleClipboardResponse = (successMessage?: string) => {
    if ((successMessage?.length ?? 0) > 0) {
      toaster.pop('success', undefined, successMessage);
    }
  };

  return {
    copy,
    isSupported
  };
}
